import { Component, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicFormComponent, Group, UtilsService } from 'app/core';
import { GroupDataQuestionsService } from '../questions-services/group-data-questions.service';
import { DefaultDataQuestionsService } from '../questions-services/default-data-questions.service';
import { MarsDataQuestionsService } from '../questions-services/mars-data-questions.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MarsGroupService } from 'app/mars/services/mars-groups.service';

@Component({
  selector: 'lms-mars-group-data',
  templateUrl: './mars-group-data.component.html',
  styleUrls: ['./mars-group-data.component.scss'],
  providers: [GroupDataQuestionsService, DefaultDataQuestionsService, MarsDataQuestionsService] // TODO
})
export class MarsGroupDataComponent implements OnInit, OnChanges, OnDestroy {
  @Input() group: Group;
  @Input() data: any = {};
  @Output() save = new EventEmitter<Group>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public groupData: any = {};
  public modalChecked = false;
  private loggedUserSubscription: Subscription = new Subscription();

  constructor(
    public route: ActivatedRoute,
    public groupsService: MarsGroupService,
    public questionsService: GroupDataQuestionsService,
    public defaultQuestionsService: DefaultDataQuestionsService,
    public translate: TranslateService
  ) {}

  public ngOnInit() {
    this.route.data.subscribe((data) => {
      if (data.questionsDataScheme) {
        this.data = UtilsService.getQuestionsData(this.route.snapshot, data.questionsDataScheme);
      }
    });
  }

  public ngOnChanges() {
    if (this.group) {
      this.setQuestionsData();
    }
  }

  public ngOnDestroy() {
    this.loggedUserSubscription.unsubscribe();
  }

  setQuestionsData() {
    this.data = Object.assign({}, this.data, { group: this.group });
  }

  submit(groupData: any) {
    this.saveGroup(groupData);
  }

  saveGroup(groupData: any) {
    if (this.data.group) {
      this.onUpdate(groupData);
    } else {
      this.onCreate(groupData);
    }
  }

  onCreate(groupData: Object) {
    this.groupsService
      .create(groupData)
      .then((group) => {
        this.save.emit(group);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: any) {
    const updatedgroup: Group = Object.assign({}, this.data.group, updatedData);
    this.groupsService
      .update(updatedgroup)
      .then((savedGroup) => {
        this.save.emit(savedGroup);
        this.endSubmit(null);
        this.modalChecked = false;
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
